import React from "react"
import useT from "../hooks/useT"
import LegalPage from "./LegalPage"
import en from "../legal/en/refunds.md?raw"
import bg from "../legal/bg/vazstanovyavane-na-sumi.md?raw"

const TEXTS = { en, bg }

export default function RefundsPage() {
  const t = useT()
  return <LegalPage title={t`Refunds Policy`} texts={TEXTS} />
}
